export const environment = {
  name: 'Dev',
  production: false,
  baseServerUrl: 'https://dev.api.cratebase.io',
  apiBaseUrl: 'https://dev.api.cratebase.io/api/v1',
  apiAdminBaseUrl: 'https://dev.api.cratebase.io',
  sentryDSN: '',
  userAgent: 'Cratebase/0.0.4+https://dev.api.cratebase.io',
  postNordUrl: '',
  postNordTrackingUrl: '',
  mixpanelToken: '9c9fff2aeb226c46e393e4421665c917',
  version: require('../../package.json').version,
  shopify_site_api_version: '2023-04',
  postnlTrackingUrl: 'https://jouw.postnl.nl/track-and-trace',
  scaleApiUrl: 'https://localhost:3001/current-weight',
  adminDashboardKey: 'a7f3c2d9e8b1f4a6c3d5e7f9a2b4c6d8e1f3a5b7c9d2e4f6a8b1c3d5e7f9a2b4',
};
